import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

import './article.css';

const ArticleLayout = ({ title, subtitle, children }) => {
  const navigate = useNavigate();

  return (
    <main className="article-page-container">

      <FontAwesomeIcon
        icon={faArrowLeft}
        size="lg"
        style={{ cursor: 'pointer' , paddingBottom: '20px'}}
        onClick={() => navigate('/specs')}
      /> 

      <h1 className="article-title">{title}</h1>
      {subtitle && <p className="article-subtitle">{subtitle}</p>}
      <div className="article-content">{children}</div>
    </main>
  );
};

export default ArticleLayout;
